import {IPickup} from '../types/FundraiserTypes.ts';
import moment from 'moment/moment';

export function formatPickupLocation(pickup: IPickup) {
    return `${pickup.location}: ${moment(pickup.startTime).format('DD/MM/YYYY [at] HH:mm')} to ${moment(pickup.endTime).format('DD/MM/YYYY [at] HH:mm')}`;
}